import React, { useRef } from "react";
import DrawerModal from "~/common/DrawerModal";
import { FacetNavigation } from "../Sidebar/Filters";
import FilterList from "../Sidebar/FilterList";
import { GroupProps } from "../Sidebar/GroupProps";
import { getNoFiltersUrl } from "../Sidebar/FilterUrlHelpers";
import { CompatibleModel } from "~/common/Store/models/Category";

interface Props extends FacetNavigation {
  pageUrl: string;
  showSearchWithinFilter?: boolean;
  showCategoryFilter?: boolean;
  showOutletConditionFilter?: boolean;
  filterComponentOrder?: ((props: GroupProps) => JSX.Element)[];
  showPartsFilter?: boolean;
  prefetch?: boolean;
  compatibleModels?: CompatibleModel[];
  toggleShowMobileFilter: () => void;
  filterMobileDialogRef: React.RefObject<HTMLDialogElement>;
  isFilterRemoved?: boolean;
}

const MobileFilters = (props: Props) => {
  const {
    pageUrl,
    showSearchWithinFilter,
    showCategoryFilter,
    showOutletConditionFilter,
    filterComponentOrder,
    showPartsFilter,
    prefetch,
    compatibleModels,
    toggleShowMobileFilter,
    filterMobileDialogRef,
    isFilterRemoved,
  } = props;

  const filterContainer = useRef<HTMLDivElement>(null);
  const noFiltersUrl = getNoFiltersUrl(pageUrl, ["order", "multi"]);

  // pushing to new url programatically here and passing that functionality to `leftControlFunction` prop
  // allows <DrawerModal/> to render a button  (this being the onClick) rather than anchor for proper
  // alignment with cancel button on the right side of mobile filters (which is a button)
  const clearFilters = () => {
    window.location.href = noFiltersUrl;
  };

  return (
    <DrawerModal
      dialogRef={filterMobileDialogRef}
      title="Filters"
      id="filterMobile"
      dialogClasses="bg-zinc-100"
      leftControlContent="Clear Filters"
      leftControlFunction={clearFilters}
      rightControlContent="Cancel"
      rightControlFunction={toggleShowMobileFilter}
    >
      <nav aria-label="filters" data-component="toolbarMenu">
        <div className="ag-filter__container" data-component="filterContainer">
          <ul className="filter-list box mt-0">
            <FilterList
              facetNavigation={props}
              filterContainer={filterContainer}
              showCategoryFilter={showCategoryFilter}
              showOutletConditionFilter={showOutletConditionFilter}
              showPartsFilter={showPartsFilter}
              pageUrl={pageUrl}
              showSearchWithinFilter={showSearchWithinFilter}
              filterComponentOrder={filterComponentOrder}
              prefetch={prefetch}
              compatibleModels={compatibleModels}
              isFilterRemoved={isFilterRemoved}
            />
          </ul>
        </div>
      </nav>
    </DrawerModal>
  );
};

export default MobileFilters;
